import { connect, ConnectedProps } from 'react-redux'
import InputTableLeftColumn, { InputTableLeftColumnCompleteRequiredProps } from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn'
import withLoading from '../../../../../../../../../../utils/hoc/withLoading'
import { ComponentTabObject } from '../../../../../../../../../../utils/hooks/useTabLogic'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../../../../utils/reducers'
import { WorkingCenterPayload } from '../../../../../../../../../../utils/reducers/company/workingCenters'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import ModalEditOrderWorkingCenter from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalEditOrderWorkingCenter'
import InputTableTopHeader from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableTopHeader'
import { Fragment } from 'react'
import { CustomSelectWithSearchBar } from '../../../../../../../../../../forms/CustomSelect'
import ITHeaderText from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import { notHaveCountersWorkingCenter } from '../../../../../../../../../../utils/globals/order/order'
import { CustomSelectBlockedItemsSearchbar } from '../../../../../../../../../../forms/CustomSelect/CustomSelectBlockedItems'
import { sortEmployeesByUser } from '../../../../../../../../../../utils/globals/employees'
import { InputWithLabelMargin } from '../../../../../../../../../../forms/Input'
import { FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import { useOrderITHeaderHandleChangeLogic } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/useOrderITHeaderHandleChange'
import { ProductTypesPayload } from '../../../../../../../../../../utils/reducers/products/productTypes'
import { AdjustmentDeliveryNoteModelType } from '@teinor/erp/types/company/order/adjustmentDeliveryNote'
import { EmployeesPayload } from '../../../../../../../../../../utils/reducers/company/employees'
import { GroupVatPayload } from '../../../../../../../../../../utils/reducers/globals/groupVats'
import useAdjustmentDeliveryNoteHeaderURLs from '../../../../../../../../../../utils/hooks/adjustmentDeliveryNote/useAdjustmentDeliveryNoteHeaderURLs'
import AdjustmentStepHeaderMain, { useAdjustmentStepHeaderMainLogic } from '../../../../header/AdjustmentStepHeaderMain'

type AdjustmentDeliveryNoteCreateStepITHeaderProps = InputTableLeftColumnCompleteRequiredProps & ReduxAdjustmentDeliveryNoteCreateStepITHeader & {}

const AdjustmentDeliveryNoteCreateStepITHeader: React.FC<AdjustmentDeliveryNoteCreateStepITHeaderProps> = ({ ...rest }) => {
    return <AppStyleDecider DefaultComponent={AdjustmentDeliveryNoteCreateStepITHeaderDefault} NewComponent={AdjustmentDeliveryNoteCreateStepITHeaderNew} {...rest} />
}

const AdjustmentDeliveryNoteCreateStepITHeaderDefault: React.FC<AdjustmentDeliveryNoteCreateStepITHeaderProps> = ({ employees, workingCenters, groupVats, ...rest }) => {
    const { t } = useTwinTranslation()
    const orderHeaderURLs = useAdjustmentDeliveryNoteHeaderURLs()
    const tabs: ComponentTabObject = {
        'main': {
            component: AdjustmentStepHeaderMain,
            text: t('dataDeliveryNote', 'Datos del albarán'),
            extraProps: { employees, workingCenters, orderHeaderURLs }
        },
    }
    return (
        <InputTableLeftColumn tabs={tabs} {...rest} />
    )
}

const AdjustmentDeliveryNoteCreateStepITHeaderNew: React.FC<AdjustmentDeliveryNoteCreateStepITHeaderProps> = ({ employees, workingCenters, getCompleteData, headerData, setCompleteData, updateDataURL, ...logic }) => {
    const { t } = useTwinTranslation()
    const orderHeaderURLs = useAdjustmentDeliveryNoteHeaderURLs()
    const { handleChange } = useOrderITHeaderHandleChangeLogic({ setCompleteData, updateDataURL })
    const { activeCurrencies, changeCurrencyId, dictWarehouses, workingCenterAddress, openModal, setOpenModal, memorizedWorkingCenters, changeWorkingCenterId } = useAdjustmentStepHeaderMainLogic({ headerData: headerData || {}, workingCenters, handleChange, setCompleteData, ...logic })

    const sections: FormRender<AdjustmentDeliveryNoteModelType> = [
        {
            cols: 7,
            className: 'gap-x-20',
            elements: [
                {
                    name: 'custom_name',
                    component: 'Custom',
                    render: (props) => {
                        return <InputWithLabelMargin name='custom_name' label={t('customName', 'Nombre personalizado')} onChange={props.onChange} defaultValue={headerData?.custom_name} className='custom_name_input_field' />
                    }
                },
                {
                    name: 'processed_date',
                    component: 'InputCalendarStateFull',
                    label: t('date', 'Fecha'),
                    className: 'custom_name_input_field',
                    onlyValids: true,
                    required: true
                },
                {
                    name: 'RepresentativeEmployeeId',
                    component: 'CustomSelectWithSearchBar',
                    label: t('representative', 'Representante'),
                    items: employees || {},
                    sortItems: true,
                    fieldName: 'fullname_short',
                    sortFunction: (emp) => sortEmployeesByUser(emp, false),
                    hideSectionByDefault: true
                },
                {
                    name: 'full_assigned_number',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('draftN', 'Nº de borrador')} value={value} className={(headerData?.assigned_number ? '' : 'text-red-BA')} />,
                    hideSectionByDefault: true
                },
                {
                    name: 'BillingWorkingCenterId',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('billedBy', 'Facturado por')} value={headerData?.BillingWorkingCenter?.name || ''} />,
                    hideSectionByDefault: true
                },
                {
                    name: 'WorkingCenterCounterId',
                    component: 'Custom',
                    render: () => <ITHeaderText label={t('serie', 'Serie')} value={headerData?.WorkingCenterCounter?.serie} />,
                    hideSectionByDefault: true
                },
                {
                    name: 'WorkingCenterId',
                    component: 'Custom',
                    render: ({ extraProps }) => {
                        return <CustomSelectBlockedItemsSearchbar label={t('requestedBy', 'Pedido por')} items={extraProps.memorizedWorkingCenters} value={extraProps.WorkingCenterId} onChange={extraProps.changeWorkingCenterId} isStateLess={true} blockItemsFnc={extraProps.notHaveCountersWorkingCenter} sortItems={true} />
                    },
                    hideSectionByDefault: true,
                    extraProps: {
                        memorizedWorkingCenters,
                        WorkingCenterId: headerData?.WorkingCenterId,
                        changeWorkingCenterId,
                        notHaveCountersWorkingCenter
                    }
                },
                {
                    name: 'WarehouseId',
                    component: 'CustomSelectWithSearchBar',
                    label: t('warehouse', 'Almacén'),
                    items: dictWarehouses,
                    sortItems: true
                },
                {
                    name: 'BillingAddressId',
                    component: 'Custom',
                    render: ({ extraProps }) => {
                        return <ITHeaderText label={t('workingCenterFiscalAddress', 'Dirección Fiscal centro de trabajo')} value={extraProps.workingCenterAddress} />
                    },
                    hideSectionByDefault: true,
                    extraProps: { workingCenterAddress }
                },
                {
                    name: 'CurrencyId',
                    component: 'Custom',
                    render: ({ extraProps }) => {
                        return <CustomSelectWithSearchBar label={t('currency', 'Moneda')} items={extraProps.activeCurrencies} value={extraProps.CurrencyId} onChange={extraProps.changeCurrencyId} isStateLess={true} />
                    },
                    hideSectionByDefault: true,
                    extraProps: {
                        activeCurrencies,
                        CurrencyId: headerData?.CurrencyId,
                        changeCurrencyId
                    }
                },
            ]
        }
    ]

    return (
        <Fragment>
            <InputTableTopHeader handleChange={handleChange} sections={sections} headerData={headerData} getCompleteData={getCompleteData} />
            {openModal?.type === 'edit' && openModal?.allRowData?.WorkingCenterId ?
                <ModalEditOrderWorkingCenter id={headerData?.id} {...{ updateWorkingCenterURL: orderHeaderURLs?.updateWorkingCenter, onSubmit: getCompleteData, setOpened: () => setOpenModal(null), allRowData: openModal?.allRowData }} />
                : null
            }
        </Fragment>
    )
}

const adjustmentDeliveryNoteCreateStepITHeaderDispatch = {
    setEmployees: (payload: EmployeesPayload) => ({ type: 'CHANGE_EMPLOYEE', payload }),
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
    setGroupVats: (payload: GroupVatPayload) => ({ type: 'CHANGE_GROUPVAT', payload }),
    setProductTypes: (payload: ProductTypesPayload) => ({ type: 'CHANGE_PRODUCT_TYPES', payload }),
}

export type ReduxAdjustmentDeliveryNoteCreateStepITHeader = ConnectedProps<typeof adjustmentDeliveryNoteCreateStepITHeaderConnect>
const mapAdjustmentDeliveryNoteCreateStepITHeaderConnector = (state: AllReduxPayloads) => ({ employees: state.employees, workingCenters: state.workingCenters, groupVats: state.groupVats, productTypes: state.productTypes})
const adjustmentDeliveryNoteCreateStepITHeaderConnect = connect(mapAdjustmentDeliveryNoteCreateStepITHeaderConnector, adjustmentDeliveryNoteCreateStepITHeaderDispatch)
const adjustmentDeliveryNoteCreateStepITHeaderConnectLoading = withLoading(AdjustmentDeliveryNoteCreateStepITHeader, [{ fetchUrl: '/api/app/employee/getAllEmployees', propName: 'employees', setFunctionName: 'setEmployees' }, { fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }, { fetchUrl: '/api/app/config/vat/getAllGroupsVat', propName: 'groupVats', setFunctionName: 'setGroupVats' }, { fetchUrl: '/api/app/product/productType/getAllProductTypes', propName: 'productTypes', setFunctionName: 'setProductTypes' } ])
const AdjustmentDeliveryNoteCreateStepITHeaderConnect = adjustmentDeliveryNoteCreateStepITHeaderConnect(adjustmentDeliveryNoteCreateStepITHeaderConnectLoading)

export default AdjustmentDeliveryNoteCreateStepITHeaderConnect